import React, {FunctionComponent} from 'react';
import {translateTemplate} from '../../../utils/translate';

interface ITranslateTemplate {
    text: string;
    replace: {};
}

const TranslateTemplate:FunctionComponent<ITranslateTemplate> = ({text, replace}) => {
    return (
        <span>
          {translateTemplate(text, replace)}
        </span>
    )
};


export default TranslateTemplate
